import { useEffect, useState } from 'react';
import useAuthStore from '@pkg/auth/useStore';

const useIsTeamLead = (entity) => {
  const { me } = useAuthStore();

  const [isTeamLead, setIsTeamLead] = useState(null);

  useEffect(() => {
    if (!entity || !me) {
      return;
    }

    setIsTeamLead(entity.lead_uuid === me.person?.uuid);
  }, [entity?.lead_uuid, me.person?.uuid]);

  return isTeamLead;
};

export default useIsTeamLead;
